export const GET_JOB_BRIEFINGS_CONSENT_REQUEST = "GET_JOB_BRIEFINGS_CONSENT_REQUEST";
export const GET_JOB_BRIEFINGS_CONSENT_SUCCESS = "GET_JOB_BRIEFINGS_CONSENT_SUCCESS";
export const GET_JOB_BRIEFINGS_CONSENT_FAILURE = "GET_JOB_BRIEFINGS_CONSENT_FAILURE";

export const PATCH_JOB_BRIEFINGS_CONSENT_REQUEST = "PATCH_JOB_BRIEFINGS_CONSENT_REQUEST";
export const PATCH_JOB_BRIEFINGS_CONSENT_SUCCESS = "PATCH_JOB_BRIEFINGS_CONSENT_SUCCESS";
export const PATCH_JOB_BRIEFINGS_CONSENT_FAILURE = "PATCH_JOB_BRIEFINGS_CONSENT_FAILURE";

export const RESET_JOB_BRIEFINGS_CONSENT = "RESET_JOB_BRIEFINGS_CONSENT";
